// extracted by mini-css-extract-plugin
export var container = "_6m-0";
export var fallback = "_6m-5";
export var fallbackIcon = "_6m-6";
export var hidden = "_6m-2";
export var image = "_6m-3";
export var loaded = "_6m-4";
export var placeholder = "_6m-1";